export default function(instance) {
  return {
    //Security Requests
    getSecurityRequests(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      if (!(Object.keys(data).length === 0 && data.constructor === Object)) {
        return instance.get("/api/security/call/admin/", {
          params: data
        });
      } else {
        return instance.get("/api/security/call/admin/");
      }
    },
    getSecurityRequest(idRequest) {
      return instance.get(`/api/security/call/admin/${idRequest}/`);
    },
    createSecurityRequest(data) {
      return instance.post(`/api/security/call/admin/`, data);
    },
    updateSecurityRequestStatus(idRequest, data) {
      return instance.put(`/api/security/call/admin/${idRequest}/`, {
        status: data.status
      });
    },
    deleteSecurityRequest(idRequest) {
      return instance.delete(`/api/security/call/admin/${idRequest}/`);
    }
  };
}
